import { apiRequest } from '@/shared/lib/api-client';

/** Estado da conversa com um colega (a lista de colegas em si vem do GET /users). */
export interface InternalConversation {
  peer_user_id: number;
  unread_count: number;
  last_message: {
    id: number;
    from_me: boolean;
    body: string | null;
    has_media: boolean;
    created_at: string;
    /** Vistos da última mensagem (só fazem sentido quando from_me). */
    delivered_at?: string | null;
    read_at?: string | null;
  };
}

/** Metadados do anexo — vêm junto da mensagem pra bolha renderizar sem lookup. */
export interface InternalMediaInfo {
  mime_type: string;
  original_name: string | null;
  size_bytes: number | null;
  width: number | null;
  height: number | null;
}

export interface InternalMessage {
  id: number;
  from_me: boolean;
  body: string | null;
  media_id: number | null;
  media?: InternalMediaInfo | null;
  created_at: string;
  /** ✓✓ cinza: o ChatPlus do destinatário recebeu. */
  delivered_at?: string | null;
  /** ✓✓ azul: o destinatário abriu a conversa. */
  read_at: string | null;
}

export interface InternalThreadPage {
  items: InternalMessage[];
  next_before: number | null;
}

export const listInternalConversations = (): Promise<InternalConversation[]> =>
  apiRequest<InternalConversation[]>('/internal-chat/conversations');

export const listInternalMessages = (
  peerId: number,
  before?: number,
): Promise<InternalThreadPage> =>
  apiRequest<InternalThreadPage>(
    `/internal-chat/messages?peer_id=${peerId}${before ? `&before=${before}` : ''}&limit=50`,
  );

export const sendInternalMessage = (input: {
  recipient_user_id: number;
  body?: string;
  media_id?: number;
}): Promise<InternalMessage & { sender_user_id: number }> =>
  apiRequest('/internal-chat/messages', { method: 'POST', body: input });

export const markInternalRead = (peerId: number): Promise<{ marked: number }> =>
  apiRequest('/internal-chat/read', { method: 'POST', body: { peer_id: peerId } });

/** "Recebi" (✓✓ cinza pro remetente). Sem ids = todas as pendentes pra mim. */
export const markInternalDelivered = (messageIds?: number[]): Promise<{ marked: number }> =>
  apiRequest('/internal-chat/delivered', {
    method: 'POST',
    body: messageIds ? { message_ids: messageIds } : {},
  });

/** Signed URL direta do R2 (TTL curto) — zero requisição de Worker de borda. */
export const getInternalMediaUrl = (
  messageId: number,
): Promise<{ url: string; mime_type: string; original_name: string | null }> =>
  apiRequest(`/internal-chat/messages/${messageId}/media-url`);
